<div #hook id="{{type}}" class="payment"></div>

<div *ngIf="error" class="alert alert-warning mt-2">
    <p class="mb-0">{{error}}</p>
</div>
